import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: '100%',
      marginTop: theme.spacing(1),
      paddingLeft: theme.spacing(1),
    },
    createCouponButton: {
      width: '180px',
      backgroundColor: '#ffffff',
      boxShadow: '0 2px 2px 0 rgba(0, 0, 0, 0.24), 0 0 2px 0 rgba(0, 0, 0, 0.12)',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    addIcon: {
      marginRight: theme.spacing(1),
      color: theme.palette.primary.main,
    },
    tableTitle: {
      marginTop: theme.spacing(3),
      marginBottom: theme.spacing(2),
      display: 'flex',
      flexWrap: 'wrap',
    },
    redeemCodeTable: {
      overflowX: 'scroll',
    },
    statusIcon: {
      fontSize: '0.5rem',
    },
    statusValid: {
      color: '#00d29c',
    },
    statusInvalid: {
      color: '#d6d6d6',
    },
    listFilterFormControl: {
      marginLeft: theme.spacing(3),
    },
    hasMoreButton: {
      color: '#999999',
      fontSize: '1.2rem',
    },
    storyDescription: {
      color: '#777777',
      fontSize: '0.8rem',
    },
    createRoot: {
      position: 'absolute',
      paddingTop: '4px',
      paddingRight: '4px',
      paddingLeft: '4px',
      bottom: '40px',
      right: theme.spacing(3),
      width: '460px',
      borderRadius: '2px',
      boxShadow: '0 24px 24px 0 rgba(0, 0, 0, 0.3), 0 0 24px 0 rgba(0, 0, 0, 0.22)',
    },
    createCouponFormContainer: {
      display: 'flex',
      flexWrap: 'wrap',
    },
    createCouponFormLabel: {
      fontSize: '0.9rem',
      color: theme.palette.text.primary,
      opacity: 0.54,
    },
    createCouponCardCancelButton: {
      color: '#aaaaaa',
      marginRight: theme.spacing(2),
    },
    createCouponCardCreateButton: {
      color: '#ffffff',
      backgroundColor: theme.palette.primary.main,
    },
    progress: {
      marginLeft: theme.spacing(2),
    },
  }),
);

export default useStyles;
